import Button from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	$backgroundImage: string;
}>`
	width: 31.9em;
	height: 25.3em;
	padding: 1.2em;
	position: relative;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	border-radius: 2.4em;
	font-size: 10px;
	transform: scale(${(props) => props.scale});
	box-shadow: 0 0.02em 0.06em 0 rgba(0, 0, 0, 0.45);
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	background-repeat: no-repeat;
`;

export const Title = styled.h1`
	margin: 1em 0 0 0;
	color: #fff;
	paint-order: stroke fill;
	-webkit-text-stroke-width: 0.2em;
	-webkit-text-stroke-color: #000;
	filter: drop-shadow(0.0108em 0.0308em 0 #000);
	font-family: "Baloo";
	font-size: 3.4em;
	font-style: normal;
	font-weight: 400;
	line-height: 91.176%;
`;

export const SubTitle = styled.p`
	color: #333;
	font-family: "Inter";
	font-size: 1.6em;
	font-style: normal;
	font-weight: 700;
	line-height: 112.5%;
`;

export const CustomButton = styled(Button)`
	width: 15.1904em;
	//margin-top: 0.8em;
	height: 2.7142em;
	font-size: 2.1em;
`;
